import styled from '@emotion/styled'
import { getFlexbox, minmax, yCustomScrollbar } from '@helpers/mixins'

const border = '1px solid var(--darkGray)'
const gutterPadding = '.5rem'

const Paper = styled.div`
	padding: 1rem;
	display: grid;
	position: relative;
	border-radius: 10px;
	grid-template-rows: 1fr 9fr 1fr;
	grid-template-areas: 'heading' 'content' 'cta';
`

const HeadingContainer = styled.div`
	${getFlexbox({ justify: 'flex-start' })}
	border-bottom: ${border};
	padding: 0.5rem ${gutterPadding};
`

const CTA = styled.div`
	${getFlexbox({ justify: 'space-between' })}
	grid-area: cta;
	border-top: ${border};
	padding: 0 ${gutterPadding};
	padding: 0.5rem;
	> button {
		padding: 0.5rem 2rem;
	}
`

const Close = styled.div`
	position: absolute;
	top: 1rem;
	right: 1rem;
`

const Content = styled.div`
	${minmax()}
	${yCustomScrollbar()}
	${getFlexbox({ flow: 'column', justify: 'flex-start', align: 'flex-start' })}
	width: 100%;
	padding: 1rem 0;
	padding-right: 0.5rem;
	overflow-y: auto;
	grid-area: content;
	> * {
		margin-bottom: 1.25rem;
	}
`

export { Close, Content, CTA, HeadingContainer, Paper }
